import { authRoles } from 'app/auth';
import i18next from 'i18next';
import enNavigation from './navigation-i18n/en';
import huNavigation from './navigation-i18n/hu';

i18next.addResourceBundle('en', 'navigation', enNavigation);
i18next.addResourceBundle('hu', 'navigation', huNavigation);

const navigationConfig = [
	/*{
		id: 'users',
		title: 'users',
		translate: 'USER',
		type: 'group',
		icon: 'apps',
		auth: [authRoles.userAccount, authRoles.userRole],
		children: [
			{
				id: 'user-list',
				title: 'Hozzáférés',
				translate: 'USER_LIST',
				type: 'item',
				icon: 'person',
				url: '/user',
				auth: authRoles.userAccount
			},
			{
				id: 'dashboard-role',
				title: 'Jogkör',
				translate: 'DASHBOARD_ROLE',
				type: 'item',
				icon: 'perm_identity',
				url: '/dashboard-role',
				auth: authRoles.userRole
			}
		]
	},*/
	{
		id: 'profiles',
		title: 'Captcha',
		translate: 'CAPTCHA',
		type: 'group',
		icon: 'apps',
		auth: [authRoles.userAccount, authRoles.userRole],
		children: [
			{
				id: 'profiles-list',
				title: 'Profile',
				type: 'item',
				icon: 'person',
				url: '/profile',
				auth: authRoles.userAccount
			},
			{
				id: 'captchatypes-list',
				title: 'Captcha Type',
				type: 'item',
				icon: 'person',
				url: '/captchatype',
				auth: authRoles.userAccount
			},
			{
				id: 'captchatogenerate-list',
				title: 'Captcha to Generate',
				type: 'item',
				icon: 'person',
				url: '/captchatogenerate',
				auth: authRoles.userAccount
			},
			{
				id: 'captchagenstat-list',
				title: 'Captcha Generation Stat',
				type: 'item',
				icon: 'person',
				url: '/captchagenstat',
				auth: authRoles.userAccount
			},
			{
				id: 'status-list',
				title: 'Status',
				type: 'item',
				icon: 'person',
				url: '/status',
				auth: authRoles.userAccount
			},
			// {
			// 	id: 'suspicion-list',
			// 	title: 'Suspicion',
			// 	type: 'item',
			// 	icon: 'person',
			// 	url: '/suspicion',
			// 	auth: authRoles.userAccount
			// }
		]
	}
];

export default navigationConfig;
